import { TrackingChangeBaseBehavior } from '@ispm-client/modules/bpmn-modeler/bpmn/tracking-changes/tracking-change-base-behavior';
import EventBus from 'diagram-js/lib/core/EventBus';
import { BpmnExtensionHelper } from '@ispm/shared/bpmn-io/bpmn-extension-helper';
import { CommandType } from '@ispm/shared/bpmn-io/bpmn-js';
import {Shape} from 'diagram-js/lib/model';
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";

export class MarkNodeUpdatedBehavior extends TrackingChangeBaseBehavior {
    constructor(eventBus: EventBus, moddle, modeling, bpmnExtensionHelper: BpmnExtensionHelper) {
        super(eventBus, moddle, modeling, bpmnExtensionHelper);
        super.postExecuted([CommandType.NODE_UPDATE_DATA], super.markElementForChange.bind(this));
    }


    getChangeType(element?: Shape) {
      const type = ModelingUtil.getTrackingChange(element)?.type;
      return type === 'added' ? 'added' : 'updated';
    }

    extractElementsFromEvent(event) {
        return event.context.ignoreTrackingChange ? [] : [event.context.element];
    }

}

